<template>
  <div>
    <div class="user_body">
      <span class="title">意见列表</span>
      <div class="search_top">
        <div class="tabs">
          <span :class="navIndex == 0 ? 'tab_select' : 'tab_nselect'" @click="navClick2(0)">全部(1)</span>
          <span class="s_line">|</span>
          <span :class="navIndex == 1 ? 'tab_select' : 'tab_nselect'" @click="navClick2(1)">未审核(1)</span>
          <span class="s_line">|</span>
          <span :class="navIndex == 2 ? 'tab_select' : 'tab_nselect'" @click="navClick2(2)">全部(1)</span>
        </div>
      
        <el-input
            placeholder="请输入内容"
            v-model="keyword"
            class="input"
            size="small"
            @keyup.enter.native="handleSearch"
          >
          <i slot="suffix" style="cursor: pointer;" class="el-input__icon el-icon-search" @click="handleSearch"></i>
          </el-input>
      </div>

      <el-table ref="multipleTable" :data="suggestionsList" :header-cell-style="tableHeaderStyle"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="title" label="文档标题" ></el-table-column>
        <el-table-column prop="category_title" label="所属栏目"></el-table-column>
        <el-table-column prop="createtime" label="提交时间"></el-table-column>
        <el-table-column prop="check" label="审核状态">
          <template slot-scope="scope">
            <span style="color:red;" :style="{color:scope.row.sh_status==0?'#FF6742':scope.row.sh_status==1?'green':'red'}">{{ scope.row.sh_status==0?'未审核':scope.row.sh_status==1?'已审核':'已驳回' }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="editSuggestion(scope.row)" type="text" size="small">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
      <div style="margin-top: 20px;margin-left: 14px;">

        <el-checkbox v-model="isChecked" @change="handleCheckedChange"></el-checkbox>
        <el-button type="plain" style="margin-left: 10px;" icon="el-icon-delete" size="small"
          @click="handleBatchDelete">批量删除</el-button>
      </div>
      <div class="footer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="total"
          small></el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
export default {
  name: "SuggestionsView",
  data() {
    return {
      tableData: [
        {
          title: "这个问题真的解决不了，阿斯达岁的",
          name: "浦发栏目",
          time: "2025-03-05",
          check: "已审核"
        },
        {
          title: "这个问题真的解决不了，阿斯达岁的",
          name: "浦发栏目",
          time: "2025-03-05",
          check: "已审核"
        }
      ],
      multipleSelection: [],
      currentPage1: 1,
      total: 10,
      navIndex: 0,
      keyword:'',
      suggestionsList:[]
    };
  },
  created(){
    this.getSuggestions();
  },
  mounted() { },
  methods: {
    handleSearch(){
      this.currentPage1 = 1;
      this.getSuggestions();
    },
    getSuggestions(){
      this.$api.getFeedbackList({page:this.currentPage1,keyword:this.keyword}).then(res=>{
        console.log('获取意见反馈列表成功',res);
        if(res.code == 1){
          this.suggestionsList = res.data.list;
          this.total = res.data.total;
        }
      }).catch(err=>{
        console.log('获取意见反馈列表失败',err);
        this.$message.error(err.msg || err.message||'获取意见反馈列表失败');
      })
    },
    editSuggestion(row){
      this.$router.push(`/addsuggestion/${row.id}`);
    },
    navClick2(index) {
      this.navIndex = index;
    },
    // 设置表头的颜色
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      return "background-color: #f9f9f9; color:#333333;"; //
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleCheckedChange(val) {
      console.log('全选', val);
      this.multipleSelection = this.tableData;
    },
    handleDelete(row){
      console.log('删除',row);
      this.$confirm('确定要删除这条意见吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((confirm) => {
        if(confirm){
          this.$api.deleteFeedback({ id: row.id }).then(res => {
            console.log('删除成功', res);
            if(res.code == 1){
              this.$message.success('删除成功');
              this.getSuggestions();
            } else {
              this.$message.error(res.msg || res.message);
            }
          }).catch(err => {
            console.log('删除失败', err);
            this.$message.error(err.msg || err.message||'删除失败');
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleBatchDelete() {
      if(this.multipleSelection.length == 0){
        this.$message.error('请选择要删除的意见');
        return;
      }
      console.log('批量删除');
      this.$confirm('确定要删除这些意见吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((confirm) => {
        if(confirm){
            this.$api.deleteFeedback({ id: this.multipleSelection.map(item => item.id).join(',') }).then(res => {
              console.log('批量删除成功', res);
              if (res.code == 1) {
              this.$message.success('批量删除成功');
              this.getSuggestions();
            } else {
              this.$message.error(res.msg || res.message);
            }
          }).catch(err => {
            console.log('批量删除失败', err);
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSelectionChange(val) {
      console.log('选中', val);
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}

.title {
  color: #666666;
  font-size: 16px;
}

.search_top {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.tabs {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}

.input {
  width: 200px;
}

.tab_select {
  color: #3c9c8f;
  font-size: 14px;
}

.tab_nselect {
  color: #666666;
  font-size: 14px;
}

.s_line {
  margin-left: 10px;
  margin-right: 10px;
  size: 16px;
  color: #999999;
}
</style>
<style>
.custom-class {
  color: red;
  background: red !important;
}

::v-deep .custom-class {
  background-color: #f0f9eb;
  /* 设置为浅绿色 */
}

.el-table {
  border-bottom: 1px solid #ebeef5;
  background: #111111;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

</style>
